import React from 'react'

import './Button.css'
import AppState from '../../../js/AppState'
import { observer } from 'mobx-react-lite'



const Button = ({external = false, children, disabled = false, onClick, scale = 1})=> {

  let cls = "Button"
  if (external)
    cls += " external"
  cls += ` ${AppState.orientation}`

  return (
    <button className={cls} onClick={onClick} disabled={disabled} style={{ "--scale": scale }}>

      <div className="Button-content">
        {children && <div className="Button-text">{children}</div>}
      </div>

    </button>
  );
}

export default observer(Button);
